import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { WebService } from '../services/web.service';
import cloneDeep from 'lodash/cloneDeep';


// import CryptoJS from "crypto-js";

@Injectable()
export class MetaDataService {
  private url = environment.API_BASE_URL;
    metadata: any = [];
    tagMetaData: any;
    tagList: any[];
    tagFilterList: any[];
    resource_category: any;


  constructor(
    private http: HttpClient,
    private webapi : WebService
  ) { }

  getMetadata(){
    return new Promise((resolve, reject) => {
    this.webapi
      .requestJson('getMetaData', {
        metadata: ['resource_category', 'resource_tags'],
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body)
          this.metadata = [response.data ];
          // this.metadata = [...response.data];
        //   this.metadata = cloneDeep(response.data);

          if (this.metadata.resourceTagCategory) {
            this.tagMetaData = this.metadata.resourceTagCategory;
            this.tagList = [...this.tagMetaData];
            this.tagFilterList = [];
            this.tagList.forEach((element) => {
              this.tagFilterList.push({
                text: element.name,
                value: element.tag_id,
                byDefault: false,
              });
            });
          }
          if (this.metadata.resourceCategory) {
            this.resource_category = this.metadata.resourceCategory;
          }
        },
        (error) => {
          // this.spinner.hide();
          var msg = error.headers.get('message');
          //   this.toast.error({
          //     title: "Error",
          //     msg,
          //     theme: 'bootstrap',
          //     timeout: 3000
          //   })
        }
      );
    })
  }

 


  
}